import React, { Component } from "react";
import menu from "../menu";
import Nav from "../../layouts/nav";
import Footer from "../../layouts/Footer";
// import ScrollToTop from "../layouts/ScrollToTop";

class Layout extends Component {
  constructor(props) {
    super(props);
    this.menu = menu;
  }
  componentDidMount() {
    this.setState({ isClient: true });
    this.props.store("mounted", true);
    this.props.services
      .checkAuthorize(this.props, "admin")
      .then(() => {
        this.props.services.checkExpiry();
      })
      .catch((err) => {});
  }
  render() {
    let props = this.props;
    let sideMenu = props.$store.sideMenu;
    return (
      <div
        id="main-wrapper"
        className={`show ${sideMenu ? "menu-toggle" : ""}`}
      >
        <Nav />
        <div
          className="content-body"
          style={{ minHeight: window.screen.height - 45 }}
        >
          {props.children}
        </div>
        <Footer />

        {/* TOP LEVEL LAYOUT MODALS */}

        {/* DATA PRIVACY MODAL */}
        <div
          className="modal fade"
          id="dataPrivacyModal"
          tabIndex="-1"
          aria-labelledby="dataPrivacyModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-xl">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="dataPrivacyModalLabel">
                  Privacy policy
                </h5>
              </div>
              <div className="modal-body">
                <p>
                  WEALTH AVENUE CONSULTANCY SERVICES PVT LTD(”Wealth Avenue”,
                  ”we”, “our” or “us”) values the users (“you”, “your” or
                  “user”) of our website (www.wealthavenue.in) or our mobile
                  application(s) (hereafter collectively referred to as
                  “Website”) and is committed to protecting your privacy and
                  personal information. We understand that you may be concerned
                  about the collection, use, and disclosure of the personally
                  identifiable information (“Personal Information”) supplied by
                  you during the course of usage of our website and the services
                  offered therein. This Privacy Policy describes the information
                  that we collect from you, how we collect this information, and
                  what we do with it after we collect it. By using the Website
                  or by providing us your information, you agree to be bound by
                  the practices described in this Privacy Policy, and also give
                  consent to the use of your Personal Information by WEALTH
                  AVENUE in accordance with the terms set out in this Privacy
                  Policy. ‘Personal information’ for purposes of this Policy
                  means information that identifies you, such as your name,
                  address, phone number or email address etc.If you have any
                  questions or comments regarding this Privacy Policy, please
                  email us at admin@wealthavenue.in
                </p>
                <p>
                  This Privacy Policy is to be read with, and is an integral
                  part of, our Terms of Use available at Terms unless otherwise
                  defined in this Privacy Policy, terms used in this Privacy
                  Policy have the same meanings as in our Terms of Use.
                </p>

                <ul>
                  <p className="para_heading">1. THE APP AND CLIENTS</p>
                  <p>
                    Company has developed and solely owns mobile personal
                    finance software applications called “WEALTH AVENUE
                    CONSULTANCY SERVICES PVT LTD”,” Wealth Avenue Consultant”,
                    “Wealth Avenue Console”, “Wealth Avenue Customer” (“App”,
                    which expression shall include future releases of the App).
                    Company makes the App available for download and use on
                    mobile phones to clients (“Clients”). Downloading and
                    installing the App shall be deemed to constitute sufficient
                    proof that Clients have read, understood and accepted this,
                    Policy.
                  </p>
                  <p className="para_heading">2. PERSONAL INFORMATION</p>
                  <p>
                    “Personal Information” means the Transaction Information as
                    defined in the Terms of Service and includes information
                    that is contained in text messages (that is, SMS) sent by
                    providers of services and/or products (including but not
                    limited to financial institutions, mobile carriers and
                    utility companies) to Clients’ mobile telephone number(s) in
                    connection with one or more transactions across multiple
                    financial accounts (including purchase, payments, billing
                    information and service notifications related thereto).
                    Without limitation, Transaction Information includes: Mobile
                    phone numbers of Clients Email addresses of Clients Partial
                    payment card data only to the extent such card data is
                    disclosed in the said messages Information related to the
                    transaction in question including identity of the service or
                    product and the price or fee paid or payable in respect
                    thereof.
                  </p>
                  <p className="para_heading">
                    3. PURPOSE OF COLLECTION AND USE OF PERSONAL INFORMATION{" "}
                  </p>
                  <p>
                    {" "}
                    Company may collect, store, access and use Personal
                    Information solely to the extent required for Company to
                    enable Clients to utilize the features of the App and to
                    provide better user experience to Clients. Such use shall
                    expressly include sharing the Personal Information with
                    Affiliates and Lenders.
                  </p>
                  <p className="para_heading">
                    4. USAGE OF GOOGLE ADVERTISING ID{" "}
                  </p>
                  <p>
                    As per the terms of Google Play Services, the Company shall
                    use the Google advertising ID when available on a device,
                    only for advertising and user analytics purposes. The
                    Company may share this ID with advertising partners only for
                    the purpose of advertising. The Company shall not connect
                    the advertising ID to any personally-identifiable
                    information without the explicit consent of Clients. The
                    Company shall abide by reset and “Opt out of Interest-based
                    Advertising” settings of Clients.
                  </p>
                  <p className="para_heading">5. DATA USE AND PRIVACY </p>
                  <p>
                    Some functionality of the App may require the transmission
                    of information provided by the User including user names and
                    passwords, mobile numbers, addresses, e-mail addresses,
                    financial information (such as credit card numbers) or GPS
                    location (“User Information”). Please do not submit any
                    personal information or data without first reading the
                    WEALTH AVENUE Privacy Policy which explains WEALTH AVENUE’s
                    data use and privacy practices in detail. If the User uses
                    such App functionality, the User shall be deemed to have
                    consented to the transmission of User Information to WEALTH
                    AVENUE, its agents and/or service providers and authorizes
                    WEALTH AVENUE, its agents and/or service providers to
                    record, process and store such User Information as necessary
                    for the App functionality and for purposes described in the
                    WEALTH AVENUE Privacy Policy. All information which User
                    provides in connection with the App, Services or these Terms
                    shall be current, true, accurate, supportable and complete.
                    User shall promptly notify WEALTH AVENUE in writing of any
                    changes to such information. The User is solely responsible
                    for maintenance of the confidentiality and security of any
                    User Information transmitted from or stored on a device for
                    purposes of the App, for all transactions and other
                    activities undertaken in the User’s name, whether authorized
                    or unauthorized. The User agrees to immediately notify
                    WEALTH AVENUE of any unauthorized transactions associated
                    with the App or any other breach of security. To the extent
                    possible under the law, WEALTH AVENUE shall not be
                    responsible for any losses arising out of the loss or theft
                    of User Information transmitted from or stored on a device
                    or from unauthorized or fraudulent transactions associated
                    with the App As servers may be located in other
                    jurisdictions your personal data and User Information may be
                    transferred to, stored, used and processed in a jurisdiction
                    other than India. You understand and consent to the transfer
                    of personal data outside India.
                  </p>
                  <p className="para_heading">
                    6. LAW AND DATA PROTECTION WEALTH AVENUE{" "}
                  </p>
                  <p>
                    can share your information with government agencies
                    regulated under the law, without obtaining your prior
                    written or verbal consent, in order to receive information
                    for the purpose of verifying identity or detection,
                    investigation, prevention including prosecution, cyber
                    incidents, punishment of offences etc, where disclosure is
                    mandatory to comply with any legal obligations. Any
                    information can be needed to be disclosed with third party
                    by WEALTH AVENUE by any order as per the law for time being
                    in force. Unsubscribe In case you are not interested to
                    receive email announcements or other marketing information
                    from our end, then please email your request at
                    admin@wealthavenue.in It may take us about 10 days for
                    processing your request.
                  </p>
                  <p className="para_heading">
                    7. PURPOSE OF USER DATA COLLECTION WEALTH AVENUE{" "}
                  </p>
                  <p>
                    will collect your information and data when you register for
                    an account or use its services or products, visit the site
                    pages or when you enter sweepstakes or promotions as
                    featured on website. On registering with this website, you
                    may be asked for your first name, last name, email address,
                    state and city of residence, gender, and date of birth. You
                    are not anonymous to wealthavenue.in once you register and
                    sign at the Website. You can be asked for your contact
                    number at the time of registration and can be send SMS
                    notifications about the sit’s services to your wireless
                    device. By registering with wealthavenue.in or Website, you
                    authorize us to send you email and text alerts to you with
                    your login details and other service needs, along with
                    promotional SMSs or emails. Your information is used to:
                    Administer or carry out obligations of the site in relation
                    to any agreement with our business partners Process orders
                    or applications submitted by you Respond to queries or
                    requests submitted by you Resolve or anticipate problems
                    with any Services supplied to you Send you details about
                    special offers or promotions. We may inform you of new
                    products or features. These might be of a third-party offers
                    or products, with which our website has a tie-up or our own
                    offers or products Send you , communications, alerts,
                    notices relevant to your use of services or products offered
                    on WEALTH AVENUE Improve the website and services provided
                    by WEALTH AVENUE. We are authorized to combine details we
                    receive from you with information you receive from
                    third-parties Some features on this website or our services
                    shall demand you to give personally identifiable information
                    as state by you under your account section at the website As
                    otherwise mentioned in this Privacy Policy
                  </p>
                  <p className="para_heading">
                    8. SHARING OF PERSONAL INFORMATION WITH THIRD PARTIES
                  </p>
                  <p>
                    Company shall not publish, sell, give on rent, trade or
                    otherwise transfer Personal Information to third parties,
                    except as may be required by law, or pursuant to the order
                    of a court or regulatory authority, or in order for Company
                    to enforce its rights, or as expressly stated by this
                    Policy. In the event Company needs to share Personal
                    Information with third parties, Company shall enter into
                    non-disclosure agreements or equivalent covenants that are,
                    at the least, as protective as the provisions of this
                    Policy.
                  </p>
                  <p className="para_heading">9. CHOICE </p>
                  <p>
                    {" "}
                    Company reasonably presumes that Clients who make available
                    Personal Information to Company are doing so out of their
                    own volition. Company does not compel Clients to disclose
                    Personal Information. At any time, Clients may opt not to
                    provide Personal Information by uninstalling the App.
                  </p>
                  <p className="para_heading">
                    10. CORRECTNESS AND INTEGRITY OF PERSONAL INFORMATION
                  </p>
                  <p>
                    Company accesses Personal Information as aforesaid from SMS
                    messages on an ‘as is’ basis. Therefore, Company shall not
                    be responsible in any way for the correctness, completeness
                    and integrity of any Personal Information collected
                    hereunder.
                  </p>
                  <p className="para_heading">11. SECURITY </p>
                  <p>
                    Company shall take all reasonable precautions by way of
                    using current industry standard encryption technologies to
                    protect Personal Information from loss, misuse and
                    unauthorized access, disclosure, alteration and destruction.
                  </p>
                  <p className="para_heading">12. AUTHORISATION FOR CONTACT </p>
                  <p>
                    By registering and/or using Website, you give authority to
                    WEALTH AVENUE and its affiliates, partners, representatives
                    etc to: Offer you Services for the product you have opted
                    for To contact you via email or phone call or SMS Provide
                    product knowledge Offer promotional offers running on WEALTH
                    AVENUE and offers by its associated third parties and
                    business partners
                  </p>
                  <p className="para_heading">13. LIMIT OF LIABILITY</p>
                  <p>
                    Notwithstanding anything to the contrary in this Policy or
                    any other terms of service or use applicable as between
                    Company and Clients, Company’s aggregate liability hereunder
                    shall be limited to Rs.1000/- (Rupees One Thousand Only) and
                    shall not extend to any indirect or remote damages
                    whatsoever, including but not limited to special,
                    incidental, consequential, or punitive damages or loss of
                    profits.
                  </p>
                  <p className="para_heading">14. ENFORCEMENT </p>
                  <p>
                    For any inquiries and complaints, the following email
                    address may be used: admin@wealthavenue.in All inquiries and
                    complaints shall be looked into promptly and without
                    charging any fee to the inquirer / complainant.
                  </p>
                  <p className="para_heading">15. COMPLIANCE </p>
                  <p>
                    Company shall always cooperate with regulatory authorities
                    and investigating agencies in India in the matter of
                    treatment of Personal Information.
                  </p>
                  <p className="para_heading">16. AMENDMENTS </p>
                  <p>
                    Company may modify this Policy in its sole discretion at any
                    time. While Company shall make best efforts to notify
                    Clients of any such modification, it shall be Clients’
                    responsibility to read and understand the Policy as
                    prevalent from time to time. Installation of the App shall
                    be deemed to constitute acceptance of the Policy as amended.
                  </p>
                  <p className="para_heading">17. DND </p>
                  <p>
                    By registering your phone number on weathavenue.in, you
                    expressly authorize us to override the national
                    Do-Not-Disturb Registry (DND) i.e. – even if your registered
                    phone number falls under DND list of National Consumer
                    Preference Registry (NCPR/NDNC), you voluntarily allow us
                    the authority to call, sms about its products, services and
                    promotional offers. You also accept & agree to our Privacy
                    Policy.
                  </p>
                  <p className="para_heading">
                    18. DISCLOSURE OF INFORMATION TO THIRD PARTIES{" "}
                  </p>
                  <p>
                    Disclosure to Successors: We may disclose your Personal
                    Information to any successor-in-interest of ours, such as a
                    company that acquires us. In the event WEALTH AVENUE goes
                    through a business transition, such as a merger or
                    acquisition by or with another company, or sale of all or a
                    portion of our assets, we reserve the right to transfer or
                    share any information we have about you with such entity and
                    the use of the information thus shared shall be governed by
                    the Privacy Policy of that entity. You will be notified via
                    email or by a notice on our Website of any such change in
                    ownership or control of your Personal Information.
                    Disclosure to Third Party Service Providers and Online
                    Partners: We may contract with various third parties who
                    help us provide, maintain and improve the Website and WEALTH
                    AVENUE Services. For example, we use a third party to
                    process payments made to us, and may subcontract out
                    production, fulfillment, analytics, reporting or other
                    operations. We also contract with several online partners to
                    help us manage, monitor and optimize our Website and the
                    WEALTH AVENUE Services and to measure the effectiveness of
                    our advertising, communications and customer/visitor
                    behavior. We use commercially reasonable efforts to prevent
                    such third parties from disclosing your Personal
                    Information, except for the purpose of providing the
                    services in question. We cannot guarantee that such third
                    parties will not disclose your Personal Information.
                    Disclosure of Non-Personal Information: We will disclose
                    Non-Personal Information, in aggregate form, to potential
                    strategic partners, advertisers, investors, customers, and
                    others. You may not opt-out of the sharing of this
                    information. However, such non-personal information cannot
                    be easily used to identify you personally. Internet
                    Advertising: We may use third party service providers to
                    serve ads on our behalf across the Internet and sometimes on
                    the Website. They may collect anonymous information about
                    your visits to our Website, and your interaction with our
                    products and services. They may also use information about
                    your visits to this and other websites to target
                    advertisements for goods and services. This anonymous
                    information is collected through the use of a web beacon,
                    which is industry standard technology used by most major
                    websites. Disclosure to Credit Rating Agencies: To make an
                    improvement in its business and service quality, WEALTH
                    AVENUE may share the personal information of a user with
                    Credit Rating Agencies or as may be directed by any
                    government regulatory/ statutory authority.
                  </p>
                  <p className="para_heading">
                    19. DATA COLLECTED BY THIRD PARTIES AND THIRD PARTY
                    ADVERTISING{" "}
                  </p>
                  <p>
                    WEALTH AVENUE may use third party service provider for
                    serving ads on our behalf over the internet and perhaps on
                    the site as well. They can collect anonymous information
                    regarding your visits to website and interaction with our
                    services and products. They can also utilize details about
                    your visits to our website or other sites for targeted
                    advertisements of services and goods. This anonymous data is
                    taken from use of pixel tag that is industry standard
                    technology utilized by many major websites. None information
                    that is personally identifiable is used or gathered in this
                    process. There may be other sites or affiliates linked to
                    wealthavenue.in. Any personal details you provide to these
                    websites or affiliates are not our property. Such affiliated
                    sites can gave different practises for privacy, and terms
                    and condition, and thus we encourage you to be updated with
                    their privacy policies and other terms when you visit them.
                    There a number of services and products such as loan and
                    credit card by third parties on our website, like lenders,
                    credit card issuers, banks and others. Such companies can
                    utilize information (excluding address, email address, name
                    and/or telephone number) regarding your visits to the
                    website for offering advertisements on the site or other
                    third party websites relevant to goods and services which
                    may or may not interest you. If you choose to apply for
                    products and/or services separately or disclose details to
                    such providers, then utilization of your details is governed
                    by their Privacy Policies.
                  </p>
                  <p className="para_heading">
                    20. PROTECTION OF PERSONAL INFORMATION{" "}
                  </p>
                  <p>
                    Personal Information: Whenever we obtain your Personal
                    Information, we use security policies and procedures to
                    protect it from unauthorized access or disclosure. To make
                    sure your personal information is secure, we communicate our
                    privacy and security guidelines to our employees and
                    strictly enforce privacy safeguards within the company.
                    However, we cannot provide any absolute guarantee of the
                    security of your Personal Information. Accordingly, we
                    assume no liability for any disclosure of data due to errors
                    in transmission, unauthorized third party access or other
                    acts of third parties, or acts or omissions beyond our
                    reasonable control. Website Content: The content that you
                    store, post, or transmit on or through the Website, may be
                    accessed by other users, including people that you do not
                    know. We are not responsible for the actions of others.
                    Therefore, you should use care in communicating with other
                    users and only disclose your Personal Information to other
                    users that you know to be trustworthy. You are responsible
                    for maintaining the confidentiality of your account
                    information and we recommend you to choose your password
                    carefully, and keep your password and computer secure by
                    signing out after using our services.
                  </p>
                  <p className="para_heading">
                    21. REVIEWING AND CHANGING YOUR PERSONAL INFORMATION
                  </p>
                  <p>
                    You can obtain a copy of your personal information and
                    request that we correct errors if any, in the same by
                    sending us an email at admin@wealthavenue.in. For your
                    protection, you will be required to provide proof of your
                    identity to obtain a copy of your personal information. You
                    may also opt out of receiving promotional communications
                    from WEALTH AVENUE or opt-out of sharing your personal
                    information with third parties by emailing us about the
                    same. If your personal information changes or if you no
                    longer want to use WEALTH AVENUE Services, you may correct,
                    update or deactivate your personal information and/or your
                    account through the account management screen. If you would
                    like us to deactivate or terminate your account you can also
                    contact us at admin@wealthavenue.in.. In case of
                    cancellation or deletion of your account, kindly note that
                    certain personal information may be retained by us, wherever
                    required or authorized by applicable law. Please remember
                    any content that has been shared by you or submitted to any
                    third party link provided via the Services may continue to
                    be available to third parties. Tell-A-Friend: If you choose
                    to use our referral service to tell a friend about the
                    Website or the WEALTH AVENUE Services, we may ask you for
                    your friend’s name, phone number and email address. We will
                    automatically send your friend a message inviting him or her
                    to visit the Website. We store this information for the sole
                    purpose of sending this message and tracking the success of
                    our referral program. Internet-based Transfers Given that
                    the Internet is a global environment, using the Internet to
                    collect and process Personal Information necessarily
                    involves the transmission of data on an international basis.
                    By providing WEALTH AVENUE with your Personal Information
                    you acknowledge and agree that we may store your Personal
                    Information and transfer it to and from our servers. We
                    endeavour to protect all Personal Information collected
                    through the Website in a safe, confidential and secure
                    manner.
                  </p>
                  <p className="para_heading">
                    22. CHILDREN’S PRIVACY WEALTH AVENUE{" "}
                  </p>
                  <p>
                    Services are intended for users ages 18 and older only.
                    Accordingly, we will not knowingly collect or use any
                    Personal Information from individuals that we know to be
                    under the age of 18. In addition, we will delete any
                    information in our database that we know originates from an
                    individual under the age of 18.
                  </p>
                  <p className="para_heading">23. COOKIE POLICY </p>
                  <p>
                    If enabled, we may place cookies on your machine that store
                    small amounts of data on your computer about your visit to
                    any of the pages of our Website. Cookies are small
                    electronic files that collect information when someone
                    visits a website. They can identify the pages that are being
                    viewed and this can assist us in tracking which of our
                    features appeal the most to you and what content you may
                    have viewed on past visits. Some cookies only exist whilst
                    viewers are online, but ‘persistent’ cookies are not
                    session-based and remain on the viewer’s computer. When you
                    visit this Website again, ‘persistent’ cookies can enable us
                    to customize our content according to your preferences.
                    Technologies such as: cookies, beacons, tags and scripts are
                    used by us and our partners like banking and financial
                    entities, affiliates, or analytics or service providers use
                    technologies such as google Ad sense, google analytics etc.
                    These technologies are used in analysing trends,
                    administering the Website, tracking users’ movements around
                    the Website and to gather demographic information about our
                    user base as a whole. We may receive reports based on the
                    use of these technologies by these companies on an
                    individual as well as aggregated basis. WEALTH AVENUE is not
                    responsible for cookies placed in the device of user/s by
                    any other website and information collected thereto.
                  </p>
                  <p className="para_heading">
                    24. TESTIMONIALS, BLOGS AND OTHER FORUMS ON WEALTH AVENUE
                    WEBSITE{" "}
                  </p>
                  <p>
                    With your consent WEALTH AVENUE may post your testimonial
                    along with your name. If you want your testimonial removed
                    please contact WEALTH AVENUE at admin@wealthavenue.in. If
                    you use a blog or other public forum on Website, any
                    information you submit there can be read, collected or used
                    by other users and could be used to send you unsolicited
                    messages. WEALTH AVENUE is not responsible for the Personal
                    Information you choose to submit in these forums.
                  </p>
                  <p className="para_heading">25. CONFIDENTIALITY </p>
                  <p>
                    Information Sharing and Disclosure We do not rent of sell
                    your information to anyone, but only as per directions in
                    the Privacy Policy. We can share the information with
                    business partner and/or affiliate. WEALTH AVENUE can also
                    sell share and/or transfer personally identifiable
                    information with successors-in-interest given a sale of any
                    part of the company’s business or on reorganization,
                    consolidation, merger of WEALTH AVENUE to another entity on
                    grounds that we are not the surviving entity. We can use
                    third party service providers for providing you our
                    services. We can ensure such parties to maintain
                    confidentiality of information provided to them as per
                    stated in our contracts. Access to your personal
                    identifiable details and account information are restricted
                    strictly and to be utilized in accordance to specific
                    internal processes for operation, development or improvement
                    of our services. We limit use and collection of your
                    personal information, but may make aggregate or anonymous
                    personal information or/and disclose these data only in
                    manner that is non-personally identifiable. The data will
                    not identify you individually.
                  </p>
                  <p className="para_heading">
                    26. CYBER SECURITY WEALTH AVENUE{" "}
                  </p>
                  <p>
                    can employ appropriate organizational or technical security
                    measures at any time in order to safeguard information
                    collected from you. We can use multiple electronic, physical
                    security and procedural measures to protect against unlawful
                    or unauthorized alteration or use of details, and against
                    any destruction, damage, or accidental loss, to information.
                    No method of electronic storage or transmission on the
                    internet, however, is hundred percent secure. Thus, we
                    cannot guarantee an absolute security. You are also
                    responsible to maintain security and confidentiality of your
                    password and login id, as we will not give these credentials
                    with unrelated third parties.
                  </p>
                  <p className="para_heading">27. LOG FILES </p>
                  <p>
                    WEALTH AVENUE uses log files, in which the details can
                    include browser type, internet protocol (IP), referring/exit
                    pages, date/stamp, platform type, internet service provider
                    (ISP), number of clicks to analyse trends, track user’s
                    movement in aggregate, administer the site, and collect
                    broad demographic data for aggregate use. We can do this to
                    improve our offered services or improve marketing, site
                    functionality or analytics. We may collate these
                    automatically from collected log information with other
                    details we collect from or about you.
                  </p>
                  <p className="para_heading">
                    28. CHANGES IN PRIVACY POLICY WEALTH AVENUE{" "}
                  </p>
                  <p>
                    does reserve the right to change or update its Privacy
                    Policy or any other policy, terms and conditions from time
                    to time as per its sole discretion. We can alter the
                    conditions and statements to reflect any changes in our
                    information practices. To stay updated, we encourage you to
                    review the Privacy Policy periodically.
                  </p>
                  <p className="para_heading">
                    29. HOW TO CONTACT WEALTH AVENUE{" "}
                  </p>
                  <p>
                    For more information about our Privacy Policy or any
                    comments related to our Services, please contact us by email
                    at admin@wealthavenue.in.or write to us at: WEALTH AVENUE
                    CONSULTANCY SERVICES PVT LTD, Master Associates P No -246/68
                    S/F School Block East Delhi 110092.
                  </p>
                  <p className="para_heading">30. GRIEVANCE OFFICER </p>
                  <p>
                    <b>Grievance redressal mechanism:</b> Customers who wish to
                    provide feedback or raise a complaint regarding our services
                    may reach us through the following channels between 10:00 am
                    and 7:00 pm, Monday to Friday (excluding national holidays):
                  </p>
                  <p>
                    <b>Level 1 – Customer Support </b>
                  </p>
                  <p>(i) Call our Customer Service Helpline: +91 8744812065 </p>
                  <p>(ii) Email us at: admin@wealthavenue.in. </p>
                  <p>
                    Our team will acknowledge your concern within 48 working
                    hours and aim to resolve it within 7 working days.{" "}
                  </p>
                  <p>
                    <b>
                      Level 2 – Escalation to Grievance Redressal Officer (GRO){" "}
                    </b>
                  </p>
                  <p>
                    If you are not satisfied with the resolution provided, or if
                    your complaint is not resolved within 7 working days, you
                    may escalate the issue to our Grievance Redressal Officer:
                  </p>
                  <p>
                    <b>Name:</b> Mr. Nikunj Mathur
                  </p>
                  <p>
                    <b>Email:</b> nikunj.mathur@wealthavenue.in
                  </p>
                  <p>
                    <b>Phone:</b> +91 9958582065 (10:30 am to 6:00 pm – Monday
                    to Friday, except national holidays)
                  </p>
                  <p>
                    If you have suggestions, concerns or questions regarding our
                    Privacy Policy, you can reach us using the contact
                    information given above.
                  </p>
                </ul>
              </div>
              <div className="modal-footer py-2">
                <button
                  type="button"
                  className="btn btn-sm btn-secondary"
                  data-bs-dismiss="modal"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* DATA STORAGE MODAL */}
        <div
          className="modal fade"
          id="dataStorageModal"
          tabIndex="-1"
          aria-labelledby="dataStorageModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-xl">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="dataStorageModalLabel">
                  Terms and Conditions
                </h5>
              </div>
              <div className="modal-body footer_modal_content">
                <ul className="ps-lg-3">
                  <p>
                    Welcome to WEALTH AVENUE CONSULTANCY SERVICES PVT LTD Pvt
                    Ltd ! Please read these terms of use (“Terms of Use”) to
                    learn about the terms and conditions that govern your usage
                    of the mobile application(s) (“App”) and all the services
                    available for use via the App (collectively, “Services”).
                    The App will be known as the “Platform”. The Platform is
                    owned and operated by WEALTH AVENUE CONSULTANCY SERVICES PVT
                    LTD, a company incorporated under the Companies Act, 2013,
                    having its registered office at WEALTH AVENUE CONSULTANCY
                    SERVICES PVT LTD, MASTER ASSOCIATES, P. NO-246/68, S/F
                    SCHOOL BLOCK, MANDAWALI, East Delhi, Delhi, 110092 (“Wealth
                    Avenue”, “Wealth”, “us”, “we”, “our”).{" "}
                  </p>
                  <p className="para_heading">1. DEFINITIONS </p>
                  <p>
                    (i) “Act”: It means and include any of the following (as
                    applicable) (a) ‘The Information and Technology Act, 2000’;
                    (b) ‘The Information and Technology (Amendment) Act, 2008’;
                    (c) ‘The Consumer Protection Act, 2019’. (ii) “Rule”: It
                    means and include any of the following (as applicable): (a)
                    The Information Technology (Reasonable Security Practices
                    and Procedures And Sensitive Personal Data or Information)
                    Rules, 2011; or (b) The Consumer Protection (E-Commerce)
                    Rules, 2020; (iii) “Company”: It shall mean and include
                    Wealth Avenue, its partners, employees, affiliates, key
                    managerial personnel etc. (iv) “Website(s)/Mobile
                    Application(s)”: It shall mean and include all websites and
                    mobile applications available for the User(s) with respect
                    to the operations of Wealth Avenue owned and managed
                    (directly or indirectly) by WEALTH AVENUE CONSULTANCY
                    SERVICES PVT LTD. (v) “Service(s)”: It means and include the
                    various services offered by Wealth Avenue to all its User(s)
                    through the Website(s)/Mobile Application(s) of Wealth. (vi)
                    “User(s)”: It shall mean and include all potential users,
                    subscribers, consumers, registered or unregistered, natural
                    or legal person, who access, subscribe or register to our
                    Website(s)/Mobile Application(s) of WEALTH AVENUE
                    CONSULTANCY SERVICES PVT LTD. (vii) “Materials”: It means
                    and includes all information, materials, functions, texts,
                    logos, designs, graphics, images, sounds, software,
                    documents, products and services provided by Basic on our
                    Website(s)/Mobile Application(s) of Wealth Avenue. (viii)
                    "User(s) Content": It means and includes all or any
                    comments, feedback, data, links, videos, audios, graphics,
                    images, messages and any other materials uploaded by the
                    Users of the said website(s)/Mobile Application(s) of Wealth
                    Avenue. (ix) “Terms of Use”: It shall mean and include all
                    terms and conditions incorporated into this agreement
                    including any updates, modification done from time to time,
                    and published in our Website(s)/Mobile Application(s) of
                    Wealth Avenue. (x) “Privacy Policy”: It shall mean and
                    include all terms and conditions incorporated into a
                    document published and available in our Website(s)/Mobile
                    Application(s) of Wealth Avenue under the heading called as
                    ‘Privacy Policy’. (xi) “User(s) Agreement”: It refers to
                    mean and include both documents i.e. the Terms of Use and
                    the Privacy Policy, as published in our website(s)/Mobile
                    Application(s) of Wealth Avenue.
                  </p>
                  <p className="para_heading">2. INTRODUCTION </p>
                  <p>
                    This user agreement ("Terms of Use") is an electronic record
                    in terms of Information Technology Act, 2000 ("Act") and
                    rules thereunder as applicable and the amended provisions
                    pertaining to electronic records in various statutes as
                    amended by the Information Technology (Amendment) Act, 2008.
                    This Terms of Use is generated by a computer system and does
                    not require any physical or digital signatures. This Terms
                    of Use govern your use of our Website(s)/Mobile
                    Application(s) of Wealth Avenue, Materials, Our Content and
                    the services offered by upon the said Website(s)/Mobile
                    Application(s) (“Service(s)”). For the purpose of this Terms
                    of Use, wherever the context so require, User(s) shall mean
                    any natural or legal person who has agreed to become a
                    member of our Website(s)/Mobile Application(s) of basic by
                    voluntarily registering on it as a registered user or
                    otherwise browses/visits our Website(s)/Mobile
                    Application(s) of basic without taking registration or
                    subscription of any kind as available during the relevant
                    time. Your access or use of the said Website(s)/Mobile
                    Application(s) is subject to the terms and conditions of use
                    as set out herein under this Terms of Use and the Privacy
                    Policy made available at our Website(s)/Mobile
                    Application(s) of basic. Please note that by accessing or
                    using the said Website(s)/Mobile Application(s), the User(s)
                    voluntarily agree to be bound by this Terms of Use and, this
                    Terms of Use is a legally binding agreement between the
                    User(s) and Wealth Avenue
                  </p>
                  <p className="para_heading">3. USER(S) REGISTRATION</p>
                  <p>
                    User(s) may use our website(s)/Mobile Application(s) of
                    Basic without registration. However, in order to personalize
                    your experience with Wealth Avenue, User(s) may create an
                    account or you can login using Mobile Number, as per the
                    functionality made available on our website(s)/Mobile
                    Application(s) of basic during the relevant time. User(s)
                    further undertake and agree to: a) provide true, accurate,
                    correct and complete information as prompted by the
                    applicable registration form made available at our
                    website(s)/Mobile Application(s) of Wealth Avenue; b)
                    Maintain and update the true, accurate, correct and complete
                    information provided by you during the registration process
                    at our website(s)/Mobile Application(s) of Wealth Avenue.
                    You may be required to choose a password and username or you
                    phone number will be your username. You are solely
                    responsible for maintaining the confidentiality of your
                    password/user name and the created account. If at any time,
                    Wealth Avenue believe that in case the account and password
                    of any User(s) is being misused in any manner, or that the
                    information provided by such User(s) during the registration
                    process is not true, inaccurate or incomplete, then Wealth
                    Avenue reserves the right to cancel your account and block
                    your access to all platforms of our Website(s)/Mobile
                    Application(s) of Wealth Avenue. User(s) are entirely
                    responsible for any and all activities that occur under
                    their account. User(s) also agree to notify with us
                    regarding any prior use or any unauthorized use of their
                    account or any breach of security. Further, we shall not be
                    liable for any loss of User(s) that may incur as a result of
                    someone else using its password or account or User(s) itself
                    failure to comply with this section.
                  </p>
                  <p className="para_heading">
                    4. USE OF OUR WEBSITE(S)/MOBILE APPLICATION(S)
                  </p>
                  <p>
                    Materials provided on our website(s)/Mobile Application(s)
                    of Wealth Avenue, including but not limited to all
                    information, materials, functions, texts, logos, designs,
                    graphics, images, sounds, software, documents, products and
                    services ("Materials"), and the selection, arrangement and
                    display thereof, may be the copyrighted works of Wealth
                    Avenue, or its vendors or third-party service providers. All
                    Materials herein and all software are owned by its partners
                    and protected by worldwide copyright and other intellectual
                    property laws as applicable. Except as stated herein, none
                    of the Materials may be modified, copied, reproduced,
                    distributed, republished, downloaded, displayed, sold,
                    compiled, posted or transmitted in any form or by any means,
                    including but not limited to, electronic, mechanical,
                    photocopying, recording or other means, without the prior
                    express written permission of Wealth Avenue. We hereby grant
                    all our User(s) the right to access and use our
                    Website(s)/Mobile Application(s) of Wealth Avenue only for
                    their personal and non-commercial use. User(s) may not use
                    it for commercial purposes or in any way that is unlawful,
                    or harms us or any other person or entity, as determined in
                    our sole discretion. User(s) may post or share any links,
                    images, texts and/or contents from our website(s)/Mobile
                    Application(s) of Wealth Avenue to social platforms like
                    Facebook, Twitter, Google+, WhatsApp, etc., with appropriate
                    link-back to the original source. Our website(s)/Mobile
                    Application(s) of Wealth Avenue including the Materials are
                    made available for public use in general and for
                    non-commercial usage only. The intellectual property (if
                    any) available in our website(s)/Mobile Application(s) of
                    Wealth Avenue including the Materials, are solely owned by
                    Wealth Avenue /its partners. In respect of the contents
                    available within our website(s)/Mobile Application(s) of
                    Wealth Avenue, including the Materials, all User(s) have to:
                    (a) Keep intact all copyright and other proprietary notices.
                    (b) Make no modifications to, and do not rent, lease, loan,
                    sell, distribute, copy or create any derivative works based
                    upon the work of Wealth Avenue or the Materials
                    created/developed/ideated by Wealth Avenue, in whole or in
                    part; (c) Not transfer any Materials or software or any part
                    thereof to any other computer or mobile device. (d) Restrain
                    from any commercial or business use of Wealth Avenue or any
                    Materials including the software etc. as the same is
                    expressly prohibited by Wealth Avenue; and (e) Ensure that
                    none of all or any functionalities, features etc. available
                    at our website(s)/Mobile Application(s) of Wealth Avenue are
                    replicated or reproduced by our User(s) or by any third
                    person at any other different website, mobile application or
                    any other platform. Except as expressly provided above,
                    nothing contained herein shall be construed as conferring,
                    by implication, estoppel or otherwise, any license or right
                    in respect of any patent, trademark or copyright of Wealth
                    Avenue upon any person. User(s) acknowledge and agree that
                    nothing in this Terms of Use shall have the effect of
                    transferring the ownership of any copyrights, trademarks,
                    service marks, trade names or any other proprietary rights
                    available with our Website(s)/Mobile Application(s) of
                    Wealth Avenue, other Materials or any part thereof to them
                    or any other third party.
                  </p>
                  <p className="para_heading">5. PROHIBITED USE</p>
                  <p>
                    As a condition of use of our website(s)/Mobile
                    Application(s) of Wealth Avenue by the User(s), they will
                    not use it for any purpose that is unlawful or prohibited by
                    these Terms of Use or by any domestic or international laws,
                    statutes, ordinances and regulations. It is clarified that
                    the use of our website(s)/Mobile Application(s) of Wealth
                    Avenue by the User(s) is the sole responsibility of the
                    User(s) itself only. You shall not display, upload, modify,
                    publish, transmit, update or share any information into our
                    Website(s)/Mobile Application(s) of Wealth Avenue that – a)
                    belongs to another person and to which you do not have any
                    right; b) is grossly harmful, harassing, blasphemous,
                    defamatory, obscene, pornographic, pedophilic, libelous,
                    invasive of another's privacy, hateful, or racially,
                    ethnically objectionable, disparaging, relating or
                    encouraging money laundering or gambling, or otherwise
                    unlawful in any manner; c) involves the transmission of
                    "junk mail", "chain letters", “unsolicited mass mailing”,
                    "spamming" or “unsolicited commercial advertisement”; d)
                    harm minors in any way; e) infringes any patent, trademark,
                    copyright or other proprietary rights; f) violates any law
                    for the time being in force; g) deceives or misleads the
                    addressee about the origin of such messages or communicates
                    any information which is grossly offensive or menacing in
                    nature; h) impersonate another person; i) contains software
                    viruses or any other computer code, files or programs
                    designed to interrupt, destroy or limit the functionality of
                    our resources/contents in general;
                  </p>
                  <p className="para_heading">6. USE OF PUBLIC FORUM </p>
                  <p>
                    Certain sections or pages of the Website(s)/Mobile
                    Application(s) of Wealth Avenue may contain a provision such
                    as chat portal for users etc. (hereinafter referred to as
                    the "Public Forum") for the users to post or upload
                    comments, feedback, data, links, videos, audios, graphics,
                    images, messages and other material ("User Content").
                    Through the Public Forum, any User(s) can communicate with
                    our other users of the Website(s)/Mobile Application(s) of
                    Wealth Avenue. User(s) are solely and entirely responsible
                    regarding all their User Content that they upload, post,
                    email, transmit or otherwise make available the same upon
                    the Public Forum. User(s) fully understand and acknowledge
                    that such User Content can be viewed by other users globally
                    and therefore User(s) shall exercise due care to ensure that
                    such User Content does not offend or abuse other users of
                    our Website(s)/Mobile Application(s) of Wealth Avenue.
                    Wealth Avenue does not control the User Content posted on
                    the Public Forum and, as such, does not guarantee the
                    accuracy, integrity or quality of such User Content. User(s)
                    understand that by using our website(s)/Mobile
                    Application(s) of Wealth Avenue they may be exposed to User
                    Content that is offensive, indecent or objectionable. Under
                    no circumstances, Wealth Avenue will be liable in any way
                    for any User Content, including, but not limited to, for any
                    errors or omissions in any User Content, or for any loss or
                    damage of any kind incurred as a result of the use of any
                    User Content posted, emailed, transmitted or otherwise made
                    available on our website(s)/Mobile Application(s) of Wealth
                    Avenue. When our User(s) post or upload their User Content
                    on our Website(s)/Mobile Application(s), they grant Wealth
                    Avenue (and its licensees, distributors, agents,
                    representatives and other authorized persons) the
                    irrevocable rights in perpetual, royalty-free, non-exclusive
                    and a license to reproduce, prepare derivative works based
                    upon such User Content, and to distribute, perform or
                    display such User Content, in whole or in part, in any form,
                    on any media or technology known or hereafter developed.
                    User Content posted by our User(s) shall be subject to the
                    relevant laws and may be disabled, or/and may be subject to
                    investigation under the appropriate laws. User(s) agree that
                    Wealth Avenue may disclose or preserve User Content if
                    required to do so by law or in the good faith belief that
                    such preservation or disclosure is reasonably necessary to:
                    (a) comply with legal process. (b) respond to claims that
                    any User Content violates the rights of third-parties; or
                    (c) protect the rights, property, or personal safety of
                    Wealth Avenue and the public. Furthermore, if any User(s)
                    are found to be in non-compliance with the laws and
                    regulations, these Terms of Use, or the Privacy Policy of
                    our Website(s)/Mobile Application(s) of Wealth Avenue may
                    terminate his/her account/block the access and, also further
                    reserve the right to remove any of such User Content that is
                    non-compliant with our policies in general. User(s) agree
                    that Wealth Avenue has no liability or responsibility for
                    the storage or deletion of any User Content and reserves the
                    right to change its general practices and limits at any time
                    in its sole discretion, with or without notice to its
                    User(s).
                  </p>
                  <p className="para_heading">7. COPYRIGHT AND TRADEMARKS</p>
                  <p>
                    Unless otherwise stated, copyright and all intellectual
                    property rights in all Materials on our Website(s)/Mobile
                    Application(s) of Wealth Avenue [including but not limited
                    to text, audio, video or graphical images, or technology,
                    the look and feel of the website/mobile application,
                    trademarks and logos appearing on our Website(s)/Mobile
                    Application(s) of Wealth Avenue may be the property of
                    Wealth Avenue and may be owned and controlled by us or by
                    other parties that have licensed their material to us.
                    Materials on our Website(s)/Mobile Application(s) are solely
                    for your personal, non-commercial use. Some content used on
                    our website(s)/Mobile Application(s) of Wealth Avenue may be
                    taken from public domain and displayed herein. User(s) are
                    bound to respect the respective intellectual property rights
                    that may subsist in such Materials made available on our
                    website(s)/Mobile Application(s). User(s) must not copy,
                    reproduce, republish, upload, post, transmit or distribute
                    the Materials in any way, including by e-mail or other
                    electronic means and whether directly or indirectly and must
                    not assist any other person to do so. Without the prior
                    written consent of the owner, modification of the Materials,
                    use of the Materials on any other web site or networked
                    computer environment or use of the Materials for any purpose
                    other than personal, non-commercial use is a violation of
                    the copyrights, trademarks and other proprietary rights, and
                    is strictly prohibited. Any use for which the User(s)
                    receive any remuneration, whether in money or otherwise, is
                    a commercial use for the purposes of this clause. User(s)
                    agree not to use any framing techniques to enclose any
                    trademark or logo or other proprietary information of Wealth
                    Avenue or remove, conceal or obliterate any copyright or
                    other proprietary notice or any credit-line or date-line on
                    other mark or source identifier included on our
                    website(s)/Mobile Application(s) of Wealth Avenue including
                    without limitation, the size, colour, location or style of
                    all proprietary marks. Any infringement shall be vigorously
                    defended and pursued to the fullest extent as permitted by
                    the appropriate laws. We respect other people's intellectual
                    property rights and if you believe that any content or
                    material on our website(s)/Mobile Application(s) of Wealth
                    Avenue infringes on your intellectual property rights, the
                    User(s) or any other concerned person is requested to send a
                    mail on admin@wealthavenue.in in order to know further
                    details for necessary action. It is expressly clarified that
                    any sponsored content of any goods/service/activity
                    (expressly displayed at respective portions on our
                    website(s)/Mobile Application(s) of Wealth Avenue displayed
                    are not solicited by Wealth Avenue and it should not be
                    deemed as a promotion made at the behest of Wealth Avenue.
                  </p>
                  <p className="para_heading">8. INTERNATIONAL USE</p>
                  <p>
                    Wealth Avenue is a company incorporated as per the laws
                    applicable in India and it makes no representation that our
                    website(s)/Mobile Application(s) of Wealth Avenue is
                    appropriate or available in locations outside of India.
                    Those who choose to access it from other locations do so at
                    their own risk and are solely responsible for compliance
                    with applicable laws.
                  </p>
                  <p className="para_heading">
                    9. DISCLAIMER AND LIMITATION OF LIABILITY
                  </p>
                  <p>
                    (a) By accessing and/or using our website(s)/Mobile
                    Application(s) of Wealth Avenue and its service (hereinafter
                    referred to as the “Service”), User(s) have read, understood
                    and agree to be legally bound by the terms of this
                    disclaimer. User(s) agree that your access to the Service is
                    at your sole risk and at your free will. (b) The Service and
                    all material therein contained are distributed and
                    transmitted on an "as is" and "as available" basis. (c) We
                    disclaim any and all express or implied representations,
                    warranties and/or conditions of any kind, including but not
                    limited to warranties of completeness, accuracy,
                    reliability, suitability, fitness, merchantability,
                    availability, quality, fitness for any purpose,
                    non-infringement, compatibility and/or security; (d) We are
                    not responsible or liable for any infection or contamination
                    of your system or device arising out of or in connection
                    with your use of the Service or any connected service and do
                    not warrant that the Service, the server(s) that make the
                    Service available or any connected services are free from
                    viruses, trojan horses, worms, software bombs or similar
                    items or processes or other harmful components; (e) We are
                    not responsible or liable for interruptions, delays,
                    inaccuracies, errors, or omissions arising out of your use
                    of the Service or any connected service or with respect to
                    the material and user material thereon; and (f) We do not
                    warrant that the Service, or any connected service, linked
                    microsites, any materials, third-party content, other
                    services offered will be uninterrupted or error free or
                    accurate or suit your purpose. (g) Industry standard efforts
                    are made to keep the Service running smoothly. However,
                    Wealth Avenue takes no responsibility for, and will not be
                    liable for, the Service being unavailable due to any
                    reasons. (h) The entire risk as to the quality, accuracy,
                    adequacy, completeness, fitness, correctness and validity of
                    any material and use of and access to the Service or any
                    connected service rests solely with you. (i) User(s) may
                    encounter third party applications while using the Service
                    including, without limitation, websites, widgets, software,
                    services that interact with the service. Your/User(s) use of
                    these third-party applications shall be subject to such
                    third-party terms of use or license terms. Wealth Avenue
                    shall not be liable for any representations or warranties or
                    obligations made by such third-party applications to you
                    under contract or law. (j) The Service may contain links to
                    other third-party websites/services which are not under the
                    control of Wealth Avenue Any website/application you visit
                    by a link from the Service is solely the responsibility of
                    the third party providing the website. The content of,
                    including materials and information contained on, any
                    third-party website/application to which you link from the
                    Service is solely the responsibility of the provider of that
                    third party website/application. Any transactions that you
                    enter into with a third party listed in this Service or
                    linked from this Service are solely between you and that
                    third party. We are not responsible for any such third-party
                    content/feature that may be accessed via the Service, nor
                    the organizations publishing those third-party
                    websites/applications, and hereby disclaim any
                    responsibility and liability for such content. The inclusion
                    of any links does not constitute or imply an endorsement or
                    recommendation by us of the third-party, of the quality of
                    any product or service, advice, information or other
                    materials displayed, purchased, or obtained by you as a
                    result of an advertisement/functionality/necessary embedment
                    or integrations, any other information or offer in or in
                    connection with the third-party website/application. (k)
                    When the User(s) share password or allow a third party to
                    access his/her account, he/she agrees to remain responsible
                    for compliance with this Terms of Use by any such third
                    party. We will not be liable for any loss or damage arising
                    from your failure to adequately safeguard your password or
                    for any actions occurring under your password. (l) User(s)
                    agree that Wealth Avenue shall not be liable for any direct,
                    special, incidental, indirect or consequential damages of
                    any kind in connection with this agreement or your use of
                    our Website(s)/Mobile Application(s) of Wealth Avenue even
                    if Wealth Avenue has been informed in advance of the
                    possibility of such damages. (m) Notwithstanding the
                    foregoing, in no event shall Wealth Avenue or its
                    affiliates, associates and group companies' liability to you
                    for any and all losses, damages or claims of whatsoever
                    nature (whether in contract, tort, breach of statutory duty
                    or otherwise) including under the Privacy Policy shall
                    exceed the amount paid by you, if any, for accessing the
                    Service provided. However, the maximum liability, in any
                    case, whatsoever, of Wealth Avenue in all instances shall
                    not exceed INR 500 (Indian National Rupees Five Hundred
                    only). (n) If you are dissatisfied with the Service or with
                    these Terms of Use or the Privacy Policy of our
                    Website(s)/Mobile Application(s) of Wealth Avenue your sole
                    and exclusive remedy is to discontinue accessing or using
                    the Service.
                  </p>
                  <p className="para_heading">
                    10. INDEMNITY User(s) agree to indemnify, defend and
                  </p>
                  <p>
                    hold Company, its officers, directors, employees, affiliates
                    or representatives harmless from any claim or action
                    (including legal expenses) arising out of your use of our
                    Website(s)/Mobile Application(s) of Wealth Avenue your
                    breach of the Terms of Use, Privacy Policy and violation of
                    any third party intellectual property rights or privacy in
                    any way.
                  </p>
                  <p className="para_heading">11. CHANGES OF TERMS OF USE </p>
                  <p>
                    We reserve our right to modify these Terms of Use and the
                    Privacy Policy at any time, at our sole discretion. Any
                    changes to Terms of Use or the Privacy Policy will be posted
                    on our Website(s)/Mobile Application(s) of Wealth Avenue and
                    your continued use of the same following a posting of such
                    change is your agreement to all such changes made & updated
                    and, all User(s) are bound by the then-current version of
                    these Terms of Use or the Privacy Policy inserted upon our
                    Website(s)/Mobile Application(s) of Wealth Avenue If any
                    changes to these Terms of Use or the Privacy Policy are
                    unacceptable to you, you must discontinue using our
                    Website(s)/Mobile Application(s) of Wealth Avenue We reserve
                    the right to suspend or deny, in our sole discretion, your
                    access to all or any portion of our Website(s)/Mobile
                    Application(s) of Wealth Avenue including for any violation
                    of any provision of these Terms of Use and/or the Privacy
                    Policy. We also reserve the right to change our
                    website(s)/Mobile Application(s) of Wealth Avenue without
                    any prior notice to the User(s), at any time.
                  </p>
                  <p className="para_heading">12. RELATIONSHIP </p>
                  <p>
                    None of the provisions of the Terms of Use and the Privacy
                    Policy shall be deemed to constitute a partnership or agency
                    between the User(s) and Wealth Avenue and, User(s) shall
                    have no authority to bind Wealth Avenue in any manner,
                    whatsoever. If the User(s) are registering on our
                    Website(s)/Mobile Application(s) of Wealth Avenue as a
                    business entity, you represent that you have the authority
                    to bind your entity with all terms of this Terms of Use and
                    the Privacy Policy of our Website(s)/Mobile Application(s)
                    of Wealth Avenue. 13. Authorization to collect Credit
                    report. User hereby authorizes BEPL to collect its credit
                    report on its behalf. All information contained in this
                    credit report has been collated basis their Credit
                    Information which may be available at various authorized
                    Government databases, Semi-Government or private
                    organizations and the information provided by them to Basic.
                    Other terms related to this Credit Report Authorization
                    shall be governed by the “Terms- Credit Report.”
                  </p>
                  <p className="para_heading">13. TERMINATION </p>
                  <p>
                    We reserve the right, at our discretion, to immediately,
                    with or without notice, suspend or terminate your
                    registration/subscription, the Terms of Use, and/or your
                    access to all or a portion of our website(s)/Mobile
                    Application(s) of Wealth Avenue and/or remove any
                    registration information or User Content from our
                    Website(s)/Mobile Application(s) of Wealth Avenue for any
                    reason. Upon termination or expiration of the Terms of Use
                    or of your registration/subscription, your obligations and
                    Wealth Avenue’s rights and disclaimers survive, but your
                    right to use our Website(s)/Mobile Application(s) of Wealth
                    Avenue immediately ceases. Any express waiver or failure to
                    exercise promptly any right under the Terms of Use will not
                    create a continuing waiver or any expectation of
                    non-enforcement.
                  </p>
                  <p className="para_heading">14. MISCELLANEOUS </p>
                  <ul>
                    <li className="mb-2">
                      (a) These Terms of Use contain the entire understanding
                      between User(s) and Wealth Avenue and supersedes all prior
                      understanding between the User(s) and Wealth Avenue in
                      respect of the User(s)'s access and/or use of the Service.{" "}
                    </li>
                    <li className="mb-2">
                      (b) If any provision of these Terms of Use is found to be
                      illegal, invalid or unenforceable, then to the extent to
                      which such provision is illegal, invalid or otherwise
                      unenforceable, it shall be severed and deleted and the
                      remaining provisions shall survive and remain in full
                      force and effect and continue to be binding and
                      enforceable.{" "}
                    </li>
                    <li className="mb-2">
                      (c) User(s) confirm that their representations,
                      warranties, undertakings and covenants, and the clauses
                      relating to indemnities, limitation of liability, grant of
                      license, governing law, confidentiality shall survive the
                      efflux of time and the termination of these Terms of Use
                      and the Privacy Policy of our Website(s)/Mobile
                      Application(s) of Wealth Avenue.{" "}
                    </li>
                    <li className="mb-2">
                      (d) Any express waiver or failure to exercise promptly any
                      right under these Terms of Use and the Privacy Policy of
                      our Website(s)/Mobile Application(s) of Wealth Avenue will
                      not create a continuing waiver or any expectation of
                      non-enforcement.{" "}
                    </li>
                    <li className="mb-2">
                      (e) User(s) agree that Wealth Avenue shall be under no
                      liability whatsoever to its User(s) in the event of
                      non-availability of the Service or any portion thereof
                      occasioned by Act of God, pandemic, war, disease,
                      revolution, riot, civil commotion, strike, lockout, flood,
                      fire, satellite failure, network failures, server
                      failures, failure of any public utility, terrorist attack,
                      network maintenance, service maintenance, server
                      maintenance, or any other cause whatsoever beyond the
                      control of Wealth Avenue.{" "}
                    </li>
                    <li className="mb-2">
                      (f) Unless otherwise specified, the Service is presented
                      solely for the purpose of entertainment and promoting
                      programs. Wealth Avenue makes no representation that the
                      Service is appropriate or available for use in locations
                      other than India. Those who choose to access the Service
                      from locations other than in India, do so on their own
                      initiative and risk, and are solely responsible for
                      compliance with the relevant applicable local laws.{" "}
                    </li>
                    <li className="mb-2">
                      (g) The Privacy Policy (as also provided in our
                      Website(s)/Mobile Application(s) of Wealth Avenue and any
                      other documents, instructions, etc. included on our
                      Website(s)/Mobile Application(s) of Wealth Avenue shall be
                      read into this and shall be a part of these Terms of Use.
                      The Privacy Policy shall form an integral part of the
                      Terms of Use and both these documents constitute the
                      User(s) Agreement and a legally binding contract between
                      Wealth Avenue and the User(s).{" "}
                    </li>
                    <li className="mb-2">
                      (h) These Terms of Use shall be governed by and construed
                      in accordance with the laws of the India and be subject to
                      the exclusive jurisdiction of the Courts at Delhi (India),
                      without giving effect to any principles of conflicts of
                      law.
                    </li>
                  </ul>
                </ul>
              </div>
              <div className="modal-footer py-2">
                <button
                  type="button"
                  className="btn btn-sm btn-secondary"
                  data-bs-dismiss="modal"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default constore(Layout);
